import styled from "styled-components";

export const Container = styled.div`
  .videoContainer {
    display: flex;
    flex-direction: column;
    margin: 15px 0;
    background-color: ${({ theme }) => theme.colors.white};
    justify-content: space-evenly;
    padding: 15px;
    min-height: 156px;
    border-radius: 2px;
    box-shadow: rgba(3, 3, 3, 0.1) 2px 0px 10px;
  }

  .filterSection {
    display: flex;
    flex-direction: column;
    max-width: 343px;
    gap: 10px;
    margin-bottom: 20px;
  }

  .filterTabs {
    margin-top: 10px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: rgba(3, 3, 3, 0.1) 2px 2px 4px;
  }

  .videoList {
    margin-top: 15px;
    min-height: 60vh;
  }

  .statusBadge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    display: inline-block;
    text-transform: capitalize;
  }

  .statusReady {
    background-color: #e3f7e8;
    color: #178344;
  }

  .statusProcessing {
    background-color: #fff8e1;
    color: #ffa000;
  }

  .statusError {
    background-color: #ffebee;
    color: #d32f2f;
  }

  @media (min-width: 800px) {
    .filterSection {
      flex-direction: row;
      align-items: center;
      max-width: 100%;
      justify-content: space-between;
    }

    .filterTabs {
      margin-top: 0;
    }
  }
`;
